module.exports = __webpack_public_path__ + "static/application-web.5d18daf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/application-web.jpg
// module id = 843
// module chunks = 267660657819475